/**
 * Gap between a rail trigger and the popover it opens.
 *
 * Larger than the design system's default because the trigger is a 40px icon
 * centred in a 75px rail: an offset measured from the icon has to clear the
 * remaining rail and its border, or the panel opens on top of the navigation.
 * This value puts the panel's left edge level with the rail's, matching the
 * design.
 */
export const RAIL_POPOVER_SIDE_OFFSET = 16;
